import { BreadcrumbDesignTokens } from '@primeuix/themes/aura/breadcrumb';

export const breadcrumbTokens: BreadcrumbDesignTokens = {
  root: {
    padding: '1rem',
    background: '{content.background}',
    gap: '0.5rem',
    transitionDuration: '{transition.duration}',
  },
  item: {
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    icon: {
      color: '{text.muted.color}',
      hoverColor: '{text.color}',
    },
    borderRadius: '{content.border.radius}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    gap: '{navigation.item.gap}',
  },
  separator: {
    color: '{navigation.item.icon.color}',
  },
};
